"use strict";var e=require("styled-components"),r=require("./mystiqueLoader.js"),o=require("react/jsx-runtime");function a(e){return e&&e.__esModule?e:{default:e}}var i=a(e);const l=e.css`
  flex-grow: 4;
  width: 100%;
  border: 1px solid;
  border-color: var(--color-primary);
  border-radius: 10px;
  padding: 4px;
  font-size: var(
    --typography-size-${e=>"small"===e.size?"s1":"s2"}
  );

  &.type-success {
    border-color: var(--color-success);
    color: var(--color-success);
  }
  &.type-danger {
    border-color: var(--color-error);
    color: var(--color-error);
  }
  &.type-info {
    border-color: var(--color-help);
    color: var(--color-help);
  }
  &.type-warning {
    border-color: var(--color-warning);
    color: var(--color-warning);
  }
  &.type-white {
    border-color: var(--color-white);
    color: var(--color-white);
  }
  &.type-black {
    border-color: var(--color-black2);
    color: var(--color-black2);
  }

  &:disabled {
    border-color: var(--color-disabled);
    color: var(--color-disabled);
    color: var(--color-black2);
  }
`,t=i.default.input.withConfig({displayName:"Input__InputStyled",componentId:"sc-1e253gs-0"})([""," &::-webkit-outer-spin-button,&::-webkit-inner-spin-button{-webkit-appearance:none;margin:0;}&[type='number']{-moz-appearance:textfield;}:focus{border-width:1.5px;}&.size-small{font-size:var(--typography-size-s1);}&.size-medium{font-size:var(--typography-size-s2);}&.size-large{font-size:var(--typography-size-s3);}&.align-center{text-align:center;}&.align-right{text-align:right;}"],l),n=i.default.div.withConfig({displayName:"Input__InputLoading",componentId:"sc-1e253gs-1"})([""," display:flex;align-items:center;&.align-center{justify-content:center;}&.align-right{align-items:center;justify-content:flex-end;}"],l);exports.I=({htmlType:e="text",className:a="",type:i="primary",size:l="medium",align:s="left",disabled:c=!1,loading:d=!1,onClick:p=()=>{},onChange:g,value:u})=>{const y=`${a} type-${i} size-${l} align-${s}`;return d?o.jsx(n,{size:l,className:y,align:s,children:o.jsx(r.default,{size:l,type:i})}):o.jsx(t,{className:y,type:e,value:u,align:s,size:l,disabled:c,onClick:p,onChange:g})};